import {Config} from "./config";

export const Global = {
  ...Config,

  // Purchase order
  API_GET_ALL_PO: 'PurchaseOrder/GetPurchaseOrders',
  API_GET_ALL_PO_AU: 'PurchaseOrder/GetPurchaseOrdersByAU',
  API_GET_ID_PO: 'PurchaseOrder/GetPurchaseOrderById/',
  API_GET_NU_PO: 'PurchaseOrder/GetPurchaseOrderByNumber/',
  API_UPDATE_ASSIG_PO: 'PurchaseOrder/UpdateOrderByAssigns',
  API_STOP_ASSIG_PO: 'PurchaseOrder/StopOrderByAssigns/',
  API_STOP_ASSIG_POL: 'PurchaseOrder/StopOrderByAssignsSpecific/',
  API_GET_ALL_PO_BY_USR: 'PurchaseOrder/GetPurchaseOrders/',


  // Purchase order line
  API_GET_ALL_POL: 'PurchaseOrderLine/GetPurchaseOrderLines',
  API_GET_POL_BY_ON: 'PurchaseOrderLine/GetPurchaseOrderLinesByON/',
  API_POST_FILES_POL: 'PurchaseOrderLine/UploadFile',
  API_GET_DOC_POL_US: 'PurchaseOrderLine/GetDocumentPerApprove/',
  API_GET_DOC_POL_US_NEW: 'PurchaseOrderLine/GetDocumentPerApproveNew/',
  API_DOWNLOAD_FILE_POL: 'PurchaseOrderLine/DownloadFile/',
  API_APPROVE_FILE_POL: 'PurchaseOrderLine/ApproveDocument',
  API_APPROVE_ALLFILE_POL: 'PurchaseOrderLine/ApproveAllDocument',
  API_GET_COLUMNS_NAME_POL: 'PurchaseOrderLine/ColumnsName',
  API_GET_ALL_POL_BY_USER: 'PurchaseOrderLine/GetPurchaseOrderLinesByUser/',
  API_GET_PERMISSIONS_BY_USER: 'PurchaseOrderLine/GetPermissionByAgent/',
  API_GET_PERMISSIONS_BY_USER_LOG: 'PurchaseOrderRepository/GetPermissionDispatch/',
  API_POST_POL: 'PurchaseOrderLine/UpdatePurchaseOrderLine',
  API_POST_CHECK_STATUS_POL: 'PurchaseOrderLine/UpdatePurchaseOrderLine',
  API_GET_FIELDS_TO_APPROVE: 'PurchaseOrderLine/GetApprovalField/',
  API_POST_APPROVE_FIELD: 'PurchaseOrderLine/ApproveField',
  API_POST_CHANGE_STATUS: 'PurchaseOrderLine/ChangeStatus',
  API_GET_ALLPOL_BY_ID: 'PurchaseOrderLine/OrderLinesById/',
  API_POST_POLUNITE: 'PurchaseOrderLine/UpdatePurchaseOrderLineUnite',
  API_GET_ASSOCIATE_DPURCHASEORDERS: 'PurchaseOrderLine/GetAssociatedPurchaseOrders',
  API_GET_REPORT_PURCHASEORDERSLINE: 'PurchaseOrderLine/GetPurchaseOrderLinesReport',

  // Purchase order detail
  API_GET_ALL_POLD: 'PurchaseOrderLineDetail/GetPurchaseOrderLinesDetail',
  API_GET_ALL_POLD_BY_USER: 'PurchaseOrderLineDetail/GetPurchaseOrderLinesDetailByUser/',
  GET_UPDATE_CAS_POLD: 'PurchaseOrderLineDetail/UpdateCASPurchaseOrderLineDetail',
  API_GET_ALL_POLD_BY_POL: "PurchaseOrderLineDetail/GetPurchaseOrderLinesDetailByPol/",
  API_GET_COLUMNS_NAME_POLD: 'PurchaseOrderLineDetail/ColumnsName',
  API_GET_PERMISSIONS_BY_USER_POLD: 'PurchaseOrderLineDetail/GetPermissionByContainers/',
  API_POST_POLD: 'PurchaseOrderLineDetail/UpdatePurchaseOrderLineDetail',
  API_GET_ALERTPOLD: 'PurchaseOrderLineDetail/GetAlertContainer/',
  API_GET_CONTAINER_NUMBER: 'PurchaseOrderLineDetail/GetContainersByPurchaseOrder/',
  API_GET_CONTAINER_NUMBER_BY_ORDERID: 'PurchaseOrderLineDetail/GetPurchaseOrderLineDetailContainerNumber/',
  API_POST_CONTAINER_NUMBER: 'PurchaseOrderLineDetail/AddContainerByPurchaseOrder/',

  // Purchase Order Repository
  API_GET_ALL_POR_BY_USR: 'PurchaseOrderRepository/GetPurchaseOrdersRepository/',
  API_POST_FILES_POR: 'PurchaseOrderRepository/UploadFile',

  // Payments
  API_GET_PAYMENTS: 'Payments/GetPayments',
  API_DOWNLOAD_FILE_PY: 'Payments/DownloadFile/',


  // Maintenance - Observations
  API_GET_ALL_OB: 'Maintenance/GetObservations',
  API_CREATE_OB: 'Maintenance/CreateObservation',
  API_UPDATE_OB: 'Maintenance/UpgdateObservation',
  API_UPDATE_STATUS_OB: 'Maintenance/UpdateStatusObservation',
  API_GET_ACTIVE_OB_BY_TYPE: 'Maintenance/GetObservationsActive/',

  // Maintenance - Packaging
  API_GET_ALL_PK: 'Maintenance/GetPackagings',
  API_CREATE_PK: 'Maintenance/CreatePackaging',
  API_UPDATE_PK: 'Maintenance/UpdatePackaging',
  API_UPDATE_STATUS_PK: 'Maintenance/UpdateStatusPackaging',
  API_GET_ACTIVE_PK: "Maintenance/GetPackagingsActive",
  API_GET_ACTIVE_SC: "Maintenance/GetShippingCompaniesActive",
  API_GET_ACTIVE_TP: "Maintenance/GetTypeProductActive",
  API_GET_ACTIVE_MS: 'Maintenance/GetMonitoringStates',

  // Maintenance - Status
  API_GET_ALL_ST: 'Maintenance/GetStatus',
  API_CREATE_ST: 'Maintenance/CreateStatus',
  API_UPDATE_ST: 'Maintenance/UpdateStatus',
  API_UPDATE_STATUS_ST: 'Maintenance/UpdateStatusStatus',

  // Maintenance - Document
  API_GET_ALL_DOC: 'Maintenance/GetDocuments',
  API_CREATE_DOC: 'Maintenance/CreateDocument',


  API_UPDATE_DOC: 'Maintenance/UpdateDocument',
  API_UPDATE_STATUS_DOC: 'Maintenance/UpdateStatusDocument',
  API_GET_DOC_BY_STATUS: 'Maintenance/GetDocumentsByStatus/',

  // Maintenance - Agent
  API_GET_ALL_AG: 'Maintenance/GetAgents',
  API_CREATE_AG: 'Maintenance/CreateAgent',
  API_UPDATE_AG: 'Maintenance/UpdateAgent',
  API_UPDATE_STATUS_AG: 'Maintenance/UpdateStatusAgent',
  API_GET_AG_PERM: 'Maintenance/GetAgentsWithoutPermissions',

  // Maintenance - Alert
  API_GET_ALL_ALERT: 'Maintenance/GetAlerts',
  API_CREATE_ALERT: 'Maintenance/CreateAlert',
  API_UPDATE_STATUS_ALERT: 'Maintenance/UpdateStatusAlert',
  API_UPDATE_ALERT: 'Maintenance/UpdateAlert',

  // Maintenance - TransportCompany
  API_GET_ALL_TRS: 'Maintenance/GetTransports',
  API_CREATE_TRS: 'Maintenance/CreateTransport',
  API_UPDATE_TRS: 'Maintenance/UpdateTransport',
  API_UPDATE_STATUS_TRS: 'Maintenance/UpdateStatusTransport',
  API_GET_ACTIVE_TRS: 'Maintenance/GetTransportsActive',

  // Maintenance - Warehouse
  API_GET_ALL_WH: 'Maintenance/GetWarehouse',
  API_CREATE_WH: 'Maintenance/CreateWarehouse',
  API_UPDATE_WH: 'Maintenance/UpdateWarehouse',
  API_UPDATE_STATUS_WH: 'Maintenance/UpdateStatusWarehouse',
  API_GET_ACTIVE_WH: 'Maintenance/GetWarehouseActive/',

  // Maintenance - LiberatoryCode
  API_GET_ALL_LC: 'Maintenance/GetReleaseCodes',
  API_CREATE_LC: 'Maintenance/CreateReleaseCode',
  API_UPDATE_LC: 'Maintenance/UpdateReleaseCode',
  API_UPDATE_STATUS_LC: 'Maintenance/UpdateStatusReleaseCode',
  API_GET_SPECIFIC_LC: 'Maintenance/GetReleaseCodesSpecific/',

  // Maintenance - SystemParameter
  API_GET_ALL_SP: 'Maintenance/GetSystemParameters',
  API_CREATE_SP: 'Maintenance/CreateSystemParameter',
  API_UPDATE_SP: 'Maintenance/UpdateSystemParameter',
  API_UPDATE_STATUS_SP: 'Maintenance/UpdateStatusSystemParameter',

  // Maintenance - SystemParameterDetail
  API_GET_ALL_SPD: 'Maintenance/GetSystemParameterDetails/',
  API_CREATE_SPD: 'Maintenance/CreateSystemParameterDetail',
  API_UPDATE_SPD: 'Maintenance/UpdateSystemParameterDetail',
  API_UPDATE_STATUS_SPD: 'Maintenance/UpdateStatusSystemParameterDetail',
  API_GET_PERMISSIONS_LOG: 'Maintenance/GetPermissionChangeHistory/',

  // Maintenance - Concept
  API_GET_ALL_CONCEPT: 'Maintenance/GetConcepts',
  API_CREATE_CONCEPT: 'Maintenance/CreateConcept',
  API_UPDATE_CONCEPT: 'Maintenance/UpdateConcept',
  API_UPDATE_STATUS_CONCEPT: 'Maintenance/UpdateStatusConcept',
  API_GET_LIST_CONCEPT: 'Maintenance/GetListConcepts',


  // Maintenance - Subconcept
  API_GET_ALL_SUBCONCEPT: 'Maintenance/GetSubconcepts/',
  API_CREATE_SUBCONCEPT: 'Maintenance/CreateSubconcept',
  API_UPDATE_SUBCONCEPT: 'Maintenance/UpdateSubconcept',
  API_UPDATE_STATUS_SUBCONCEPT: 'Maintenance/UpdateStatusSubconcept',



  // Maintenance - Permissions
  API_GET_PER: 'Maintenance/GetPermissions',
  API_CREATE_PER: 'Maintenance/CreatePermissions',
  API_UPDATE_PER: 'Maintenance/UpdatePermissions',

  // Maintenance - Department
  API_GET_DEPARTMENT: 'Maintenance/GetDepartment',

  // Maintenance - Validated Custom Agent
  API_GET_CUSTOMBROKERID: 'Maintenance/ValidateCustomBrokerId/',


  // Maintenance - Additional Document

  API_GET_ADDITIONAL_DOCUMENT: 'Maintenance/GetAdditionalDocument',
  API_CREATE_ADDITIONAL_DOCUMENT: 'Maintenance/CreateAdditionalDocument',
  API_UPLOAD_ADDITIONAL_DOCUMENT: 'Maintenance/UploadAdditionalDocument',
  API_UPDATE_ADDITIONAL_DOCUMENT: 'Maintenance/UpdateAdditionalDocument',
  API_DOWNLOAD_FILE_AD: 'Maintenance/DownloadAdditionalDocumentFile/',
  API_UPDATE_STATUS_ADITIONAL_DOCUMENT: 'Maintenance/UpdateStatusAdditionalDocument/',
  API_READ_FILE_DATA_ADDITIONAL_DOCUMENT: 'Maintenance/ReadFile',
  // User
  API_SET_USER_LOG: 'User/SetUserLogged',
  API_GET_USER_LOG: 'User/UserLogged',
  API_GET_USER_ALL: 'User/GetUsers',
  API_GET_USER_INT: 'User/GetUsersInternal',
  API_GET_USER_NASS: 'User/GetUsersByExternalUnassigned',
  API_GET_USER_COMB: 'User/GetUsersByCombinated/',
  API_GET_USER_BY_AGENT: 'User/GetUserByAgent/',
  API_UPDATE_USER_LIST: 'User/UpdateUserList',
  API_UPDATE_USER: 'User/UpdateUser',
  //Log
  API_GET_SPECIFIC_LOG: 'LogTable/GetInfoLogByTable/',
  API_SAVE_SPECIFIC_LOG_COMMENT: 'LogTable/saveCommentLogTable/',


  //Report
  GET_ALL_REQUEST_INDUCTION_BY_ID: 'LogTable/GetInfoLogByTable/',
  GET_ALL_PUR_ORD: 'PurchaseOrder/GetPurchaseOrdersReport',
  GET_ALL_ENTRY_REQUEST_BY_COMPANY_ID: 'LogTable/GetInfoLogByTable/',
  GET_ALL_ENTRY_REQUEST: 'LogTable/GetInfoLogByTable/',
  GET_BY_ID_COMPANY_WORK_AUTH: 'LogTable/GetInfoLogByTable/',
  GET_ALL_WORK_AUTHS_FOR_ADMIN: 'LogTable/GetInfoLogByTable/',
  GET_ALL_COMPANIES: 'LogTable/GetInfoLogByTable/',
  GET_REPORT_REQUEST: 'LogTable/GetInfoLogByTable/',
  GET_REPORT_ENTRY_REQUEST: 'LogTable/GetInfoLogByTable/',
  GET_ALL_PUR_ORD_ALL: 'PurchaseOrderLine/GetPurchaseOrderLinesAll',
  GET_ALL_SUM_PUR_ORDER_PRODUCT_TYPE: 'PurchaseOrderLine/GetProductsSumTypeProduct',
  GET_ALL_PUR_ORD_DET_ALL: 'PurchaseOrderLineDetail/GetPurchaseOrderLinesDetailAll',
  GET_CHANGE_DISPATCH_UNITE: 'PurchaseOrder/UpdatePurchaseOrderByDispach',

  //REPORTS
  API_GET_REPORT_ARRIVALS : 'Reports/GetReportArrivals/',
  API_GET_REPORT_SETTLMENT_DAI : 'Reports/GetReportSettlementsDai/',
  API_GET_REPORT_GET_AGENT_USER : 'Reports/GetAgentUser',
  API_GET_REPORT_GET_PROVISIONS : 'Reports/GetReportProvisions/',
  API_GET_REPORT_GET_TRANSITS : 'Reports/GetReportTransits/',
  API_GET_REPORT_GET_DISPATCH_LOGISTICS : 'Reports/GetReportDispatchLogistics/',
  API_GET_REPORT_GET_PAYMENTS : 'Reports/GetPayments/',

  //NOTIFICATION
  GET_NOTIFICATION: 'Notificaciones/Notification/',
  GET_UPDATE_NOTIFICATION: 'Notificaciones/UpdateNotification/',
  GET_NOTIFICATION_CONTAINER_PENDING_PLANNING: 'Notificaciones/NotificationContainersPendingPlanning/',
  GET_NOTIFICATION_PLANNED_CONTAINERS: 'Notificaciones/NotificationPlannedContainers/',
  GET_NOTIFICATION_CONTAINERS_TO_ASSIGN: 'Notificaciones/NotificationContainerstoAssign/',
  // Items
  API_GET_ITEM: 'Items/GetItems'

};
